<div class="card">
  <div class="card-header">
    <h5 *ngIf="creditNoteList" class="me-auto">Credit Notes ({{creditNoteList().length}})&nbsp;
      <span class="ms-auto" style="cursor: pointer;" [ngbPopover]="creditNoteQuestionPopOver" triggers="click">
        <fa-icon [icon]="faQuestionCircle"></fa-icon>
      </span>
    </h5>
    <div class="button-container d-flex">
      <button type="button" class="btn ms-auto my-auto" [class.btn-primary]="showZeroBalances" [class.btn-danger]="!showZeroBalances" (click)="toggleShowZeroBalances();" [ngbTooltip]="(showZeroBalances ? 'Hide' : 'Show') + ' Zero Balances'">
        <fa-icon [icon]="(showZeroBalances) ? faToggleOn : faToggleOff"></fa-icon>
      </button>
      <button type="button" class="btn btn-primary ms-2" (click)="openCreateCreditNoteModal(CREDIT_NOTE_MODAL);">
        <fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon>
        <span>New</span>
      </button>
    </div>
  </div>
  <div class="card-body" [style.height]="cardBodyHeight">
    <div class="scrollable">
      <ul class="list-group">
        <li *ngFor="let creditNote of creditNoteList()" class="list-group-item" [ngClass]="{
          'list-group-item-action cursor-pointer': invoiceId,
          'cursor-pointer-not-allowed': !invoiceId,
          'disabled': creditNote.remainingBalance <= 0 }" (click)="invoiceId ? openApplyModal(APPLY_CREDIT_NOTE_MODAL, creditNote, $event) : return;">
          <div class="d-flex flex-row gap-3">
            <div class="d-flex flex-column amount-status-section">
              <strong class="d-flex">${{ creditNote.remainingBalance | number: '1.2-2' }} / ${{ parseCreditNoteAmount(creditNote.amount) | number: '1.2-2' }} &nbsp;<span class="badge text-bg-success mb-auto" *ngIf="invoiceId && creditNote.appliedInvoices.length > 0 && checkInvoiceIdInAppliedInvoices(creditNote.appliedInvoices, invoiceId)">Applied</span></strong>
              <p class="fw-medium mb-0">{{ creditNote.reason | creditNoteReason }}, {{creditNote.isCashExchanged ? 'Cash' : 'Cash Not'}} Exchanged</p>
              <small class="text-muted break-word" *ngIf="creditNote.notes">{{creditNote.notes}}</small>
            </div>
            <div class="ms-auto d-flex gap-2">
              <!-- Need to discuss further before enabling -->
              <!-- <button class="btn btn-primary my-auto" type="button" (click)="relinquishCreditNote(creditNote);" ngbTooltip="Relinquish">
                <fa-icon [icon]="faRotateLeft"></fa-icon>
              </button> -->
              <button class="btn btn-danger my-auto" type="button" [disabled]="creditNote.appliedInvoices.length > 0" (click)="$event.stopPropagation(); deleteCreditNote(creditNote);" ngbTooltip="Delete">
                <fa-icon [icon]="faTrashCan"></fa-icon>
              </button>
            </div>
          </div>  
        </li>
        <li *ngIf="creditNoteList().length === 0" class="list-group-item">No Credit Notes</li>
      </ul>
    </div>
  </div> 
</div>

<!-- Credit Note Question -->
<ng-template #creditNoteQuestionPopOver>
  <p class="mb-0"><strong>What is a Credit Note?</strong></p>
  <p class="mb-0">A <strong>Credit Note</strong> is a document issued by a <strong>seller</strong> to a <strong>buyer</strong> to indicate a reduction in the amount owed. It's essetially a negative invoice. Credit Notes are typically used in the following situations:</p>
  <ul>
    <li><strong>Overpayment</strong> The customer overpaid an invoice (by check, for example).</li>
    <li><strong>Referral</strong> The customer referred another customer.</li>
    <li><strong>Discount</strong> A discount applied after an issue was invoiced.</li>
    <li><strong>Refund</strong> A refund in the form of a "store credit".</li>
  </ul>
  <p class="mb-0"><strong>How to Issue a Credit Note</strong></p>
  <p>Click the "+ New" button and enter the Credit Note details.</p>
  <p class="mb-0"><strong>How to Apply a Credit Note</strong></p>
  <p class="mb-0">From the Invoice Detail page, click on a Credit Note and enter the amount (partial or total) of the Credit Note that you want to use.</p>
</ng-template>

<!-- New Credit Note Modal -->
<ng-template #CREDIT_NOTE_MODAL let-modal>
  <div class="modal-header">
    <h5 class="modal-title">New Credit Note</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="creditNoteForm">
      <div class="mb-3">
        <label for="AMOUNT">Amount </label>
        <div class="input-group">
          <div class="input-group-text">$</div>
          <input id="AMOUNT" type="number" class="form-control" placeholder="25" formControlName="amount" [min]="1" required>
        </div>
        <div *ngIf="amount.invalid && (amount.dirty || amount.touched)">
          <div *ngIf="amount.errors.required" class="input-validation-msg">Amount is required.</div>
          <div *ngIf="amount.errors.min" class="input-validation-msg">Amount greater than 0.</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="REASON">Reason</label>
        <select id="REASON" class="form-select" formControlName="reason" required>
          <option *ngFor="let reason of reasonOptions" [value]="reason.value">{{reason.label}}</option>
        </select>
        <div *ngIf="reason.invalid && (reason.dirty || reason.touched)">
          <div *ngIf="reason.errors.required" class="input-validation-msg">Reason is required.</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="NOTES">Notes</label>
        <textarea id="NOTES" class="form-control" formControlName="notes" placeholder="Enter notes here..." rows="3"></textarea>
      </div>
      <div class="form-check mb-0">
        <input id="CASH_EXCHANGED" type="checkbox" class="form-check-input" formControlName="cashExchanged">
        <label for="CASH_EXCHANGED" class="form-check-label">Cash Exchanged</label>
        <span class="ms-2" style="cursor: pointer;" ngbPopover="Select this option if money was actually exchanged for this credit note (refund in the form of credit). Keep this option unchecked if money was not exchanged (referral credit, discount)." triggers="click">
          <fa-icon [icon]="faQuestionCircle"></fa-icon>
        </span>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!creditNoteForm.valid" (click)="createCreditNoteForm();">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Cancel</button>
  </div>
</ng-template>

<!-- Apply Credit Note Modal -->
<ng-template #APPLY_CREDIT_NOTE_MODAL let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Apply Credit Note</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="applyCreditNoteForm">
      <div>
        <label for="AMOUNT">Amount </label>
        <div class="input-group">
          <div class="input-group-text">$</div>
          <input id="AMOUNT" type="number" class="form-control" placeholder="25" formControlName="amount" [min]="1" [max]="selectedCreditNoteRemainingBalance" required>
        </div>
        <div *ngIf="applyCreditNoteAmount.invalid && (applyCreditNoteAmount.dirty || applyCreditNoteAmount.touched)">
          <div *ngIf="applyCreditNoteAmount.errors.required" class="input-validation-msg">Amount is required.</div>
          <div *ngIf="applyCreditNoteAmount.errors.min" class="input-validation-msg">Amount must be greater than 0.</div>
          <div *ngIf="applyCreditNoteAmount.errors.max" class="input-validation-msg">Amount must be less than or equal to the remaining balance of {{ selectedCreditNoteRemainingBalance }}.</div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="!applyCreditNoteForm.valid || applyCreditNoteDisabled" (click)="applyCreditNote($event);">Apply</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Cancel</button>
  </div>
</ng-template>
